export const PAGE_SIZES_ARRAY = [10, 15, 25, 50, 100, 200]
export const DEFAULT_PAGE_SIZE = 10
